<template>
  <div id="app-index">
    <pub-head></pub-head>
    <pubs-nav></pubs-nav>
    <div class="nav-top">
      <div class="top-box">
        <h3>定点机构</h3>
        <p>Hospital</p>
      </div>
    </div>
    <div class="details-box">
      <div class="details-content">
        <ul>
          <li
            v-for="(item,index) in orgList  "
            :key="index"
            @click="goLink(item.link_url)"
            :class="{'click':(item.link_url && item.link_url)}"
          >
            <p v-if="item.address">{{item.org_name}} （{{item.address}}）</p>
            <p v-else>{{item.org_name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <pub-foot></pub-foot>
  </div>
</template>
<script>
import animate from "animate.css";
import pubHead from "../Public/head";
import pubsNav from "../Public/nav";
import pubFoot from "../Public/foot";

export default {
  components: {
    pubHead,
    pubsNav,
    pubFoot
  },
  data() {
    return {
      orgList: [],
      styles: {}
    };
  },
  methods: {
    getOrgList() {
      this.$db
        .post(this.$db.config.getOrgListUrl, { org_type: 3 })
        .then(res => {
          if (res.code == 200) {
            this.orgList = res.data;
          }
        });
    },

    goLink(url) {
      if (url && url != "") {
        window.open(url);
      }
    }
  },
  created() {
    this.getOrgList();
  }
};
</script>
<style lang="scss" scoped>
.click {
  cursor: pointer;
}
#app-index {
  width: 100%;
}
.nav-top {
  width: 100%;
  height: 300px;
  background: url(../../assets/images/nav_bg.png) no-repeat;
  background-size: 100% 100%;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    padding-top: 118px;
    > h3 {
      font-size: 36px;
      color: #333333;
      font-weight: normal;
    }
    > p {
      font-size: 26px;
      font-weight: normal;
      color: #999999;
    }
  }
}

.details-box {
  width: 1300px;
  margin: 0 auto;
  .details-top {
    > h3 {
      font-size: 14px;
      color: #999;
      text-align: right;
      font-weight: normal;
      padding: 28px 0 17px;
      > span {
        color: #333333;
      }
    }
  }
  .details-content {
    padding: 30px 0;
    > ul {
      display: flex;
      flex-wrap: wrap;
      > li {
        width: 50%;
        margin-top: 30px;
        > p {
          font-size: 16px;
          color: #333;
          // text-align: center;
          overflow: hidden; /*超出部分隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis; /*超出部分省略号显示*/
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_unit.vue